import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSummaryListProps } from '../@types/ProductSummaryListProps';

export const ProductSummaryListContext = createContext<ProductSummaryListProps>({} as ProductSummaryListProps);

ProductSummaryListContext.displayName = 'ProductSummaryList';

const ProductSummaryListProvider = (props: ProductSummaryListProps) => (
	<ProductSummaryListContext.Provider value={props}>{props.children}</ProductSummaryListContext.Provider>
);

export const useProductSummaryList = () => {
	const context = useContext(ProductSummaryListContext);

	return context;
};

export default ProductSummaryListProvider;
